import React, { useState, useEffect } from 'react'
import styles from './StateHeader.module.scss'
import getVectorImage from '../../../utils/getVectorImage'
import { useGeoFetch } from '../../../components/GeoProvider'
import dayjs from 'dayjs'
import typeDisplayOptions from '../../Dashboard/typeDisplayOptions'
import SelectList from '../../../components/SelectList'
import DefaultBreadcrumbs from '../../../components/Breadcrumbs/DefaultBreadcrumbs'
import Search from '../../../components/Search'
import { lastweekEndDate } from './../dates'
import regionDisplayOptions from './../regionDisplayOptions'
import MapOptions from '../../../components/MapOptions'
import dataDisplayOptions from './../dataDisplayOptions'

const HeaderDisplay = ({ headerType, dashNo, geo_id }) => {
  //const lastweekEndDate = dayjs().day(-1).format('YYYY-MM-DD')
  const [errorSubject, setErrorSubject] = useState()
  const [errorOccured, seterrorOccured] = useState(false)
  const [getgeoid, setgeoid] = useState('')
  const [getistrue, setistrue] = useState('')
  const [getDatavalue, setDatavalue] = useState('')
  const [getPercentage, setPercentage] = useState('')

  if ( errorOccured) {
    return (
      <div>
        {errorSubject !== undefined
          ? errorSubject
          : 'Unable to get the data for header'}{' '}
        : {errorSubject}
      </div>
    )
  }

  return (
    <>
      <div className={headerType === 'NAT' ? styles.natDiv : styles.stateDiv}>
        <span className={styles.firstSpan}>
          {' '}
          {getgeoid !== undefined ? getgeoid : ''}
        </span>
        <span className={styles.secondSpan}>{getVectorImage(getistrue)}</span>
        <span
          className={getistrue ? styles.stdatavalueup : styles.datavaluedown}
        >
          {' '}
          {getPercentage}%{' '}
        </span>
        <span className={styles.forthSpan}> ({getDatavalue})</span>
      </div>
    </>
  )
}

const Header = ({ headerType, headerNumber, geo_id }) => {
  const [searchCriteria, setSearchCriteria] = React.useState([])
    const [activeCbsa, setActiveCbsa] = useState()
    const { data: activeCbsasData, error: activeCbsasDataError } = useGeoFetch(
      '',
      '',
      'search',
      'locations/FLU',
      '',
      {
        geo_type: 'MSA',
      }
    )
  
    useEffect(() => {
      if (activeCbsasData !== null && activeCbsasData !== undefined) {
        setActiveCbsa(activeCbsasData)
      }
    }, [activeCbsasData])
  
    const [activeZip3, setactiveZip3] = useState()
    const { data: activeZip3Data, error: activeZip3DataError } = useGeoFetch(
      '',
      '',
      'search',
      'locations/FLU',
      '',
      {
        geo_type: 'ZIP3',
      }
    )
  
    useEffect(() => {
      if (activeZip3Data !== null && activeZip3Data !== undefined) {
        setactiveZip3(activeZip3Data.response_data)
      }
    }, [activeZip3Data])

  
  return (
    <>
      <div className={styles.pageHeader}>
        <div className={styles.pageHeaderText}>
          {/* <DefaultBreadcrumbs
            geo_id={geo_id}
            geo_type={headerType}
            dashboardType={'RSV'}
          /> */}
          <SelectList
            dropdownData={typeDisplayOptions}
            defaultValue={'uti'}
            defaultLabel={'UTI Dashboard'}
          />
        </div>
        <div className={styles.pageHeaderRight}>
          <>
            {/* <div className={styles.pageHeaderTextValue}>
              <HeaderDisplay
                headerType="NAT"
                dashNo={headerNumber}
                geo_id="NAT"
              ></HeaderDisplay>
              <HeaderDisplay
                headerType={headerType}
                dashNo={headerNumber}
                geo_id={geo_id}
              ></HeaderDisplay>
            </div> */}
            <div className={styles.pageHeaderSearch}>
              {activeCbsa !== undefined &&activeZip3!==undefined && (
            <MapOptions regionDisplayOptions={regionDisplayOptions} 
            dataDisplayOptions={dataDisplayOptions} 
            activeZip3={activeZip3} 
            activeCbsa={activeCbsa} 
            mapType={'uti'}
            dataType={'msa'}/>
          )}
            </div>
          </>
        </div>
      </div>
    </>
  )
}
export default Header
